import { render, staticRenderFns } from "./QuestionInputRadioList.vue?vue&type=template&id=f94234c0&"
import script from "./QuestionInputRadioList.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputRadioList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports